@let vm = suggestionsVm$ | async;
@if (vm; as suggestionsVm) {
  @let suggestions = suggestionsVm.suggestions.value ?? [];
  <div
    class="max-w-full py-3"
    [class.sticky]="isSuggestionCardSticky()"
    [class.top-0]="isSuggestionCardSticky()"
    [class.z-10]="isSuggestionCardSticky()"
    [style.backgroundColor]="backgroundColor() | contentBuilderColor: 'transparent'"
  >
    @if (displayType() === 'grid') {
      @if (title() || description()) {
        <div class="w-full px-5 pt-2 md:mb-4 lg:mb-6 lg:px-12">
          @if (title()) {
            <h2
              class="font-brand text-2xl text-neutral-900 lg:text-4xl"
              [style.color]="titleColor() ?? textColor() | contentBuilderColor"
            >
              {{ title() }}
            </h2>
          }
          @if (description()) {
            <p
              class="mt-3 font-base text-sm text-neutral-600 md:text-base"
              [style.color]="textColor() | contentBuilderColor"
            >
              {{ description() }}
            </p>
          }
        </div>
      }
      @if (tagColors$ | async; as tagColors) {
        <app-product-push-list-atom
          displayContext="suggestion"
          [products]="suggestions"
          [tagColors]="tagColors"
          [productNameColor]="productNameColor()"
          [productDescriptionColor]="productDescriptionColor()"
          [productPriceColor]="productPriceColor()"
          [productImagePlaceholderColor]="productImagePlaceholderColor()"
          [productBorderColor]="productBorderColor()"
          [productBackgroundColor]="productBackgroundColor()"
          [productHoverColors]="productHoverColors()"
          (requestGoToProduct)="onNavigateTo($event)"
        ></app-product-push-list-atom>
      }
    }

    @if (displayType() === 'kiosk_grid') {
      @let kioskSuggestions = visibleKioskSuggestions(suggestions);
      <div class="flex flex-col gap-2.5">
        @if (title() || description()) {
          <div class="w-full">
            @if (title()) {
              <h2
                class="kiosk-xl:text-3xl px-1 text-2xl font-semibold"
                [style.color]="titleColor() ?? textColor() | contentBuilderColor"
              >
                {{ title() }}
              </h2>
            }
            @if (description()) {
              <p
                class="px-1 mt-1 text-base"
                [style.color]="textColor() | contentBuilderColor"
              >
                {{ description() }}
              </p>
            }
          </div>
        }
        <div
          class="grid gap-5"
          [style.gridTemplateColumns]="'repeat(' + productCardColumns() + ', minmax(0, 1fr))'"
          [@staggeredListAnimation]="{
            value: kioskSuggestions.length,
            params: { animateEnterElementFromTopToBottom: true },
          }"
        >
          @for (product of kioskSuggestions; track product) {
            @if (product) {
              <app-kiosk-product-card-factory
                [isProductAvailable]="isProductAvailable(product)"
                (addProduct)="addProductDispatcher(product)"
                (showProduct)="openProductModal(product)"
                [product]="product"
                [quantity]="product.quantity"
                [textColor]="kioskFactoryTextColor()"
                [cardColor]="kioskFactoryCardColor()"
                [buttonBackgroundColor]="buttonBackgroundColor()"
                [buttonTextColor]="buttonTextColor()"
                [priceColor]="kioskFactoryPriceColor()"
                [borderColor]="kioskFactoryBorderColor()"
              ></app-kiosk-product-card-factory>
            }
          }
        </div>
      </div>
    }

    @if (displayType() === 'horizontal_highlight') {
      <app-product-card-list-atom
        displayContext="suggestion"
        [heading]="title()"
        [description]="description()"
        [products]="suggestions"
        [categoryNameColor]="titleColor()"
        [categoryDescriptionColor]="textColor()"
        [productNameColor]="productNameColor()"
        [productDescriptionColor]="productDescriptionColor()"
        [productPriceColor]="productPriceColor()"
        [productImagePlaceholderColor]="productImagePlaceholderColor()"
        [productBorderColor]="productBorderColor()"
        [productBackgroundColor]="productBackgroundColor()"
        [productHoverColors]="productHoverColors()"
        (productClick)="onNavigateTo($event)"
      ></app-product-card-list-atom>
    }
  </div>
}
